import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { FormGroup, FormControl } from '@angular/forms';
import { Entidad } from 'src/app/models/Entidad';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { InstanciaComponent } from '../instancia/instancia.component';
import { Fur } from 'src/app/models/Fur';
import { EvidenciasComponent } from '../evidencias/evidencias.component';
import {DscTituloPaginator, openModalMensaje, strMatTablePaginator} from '../../../general/Variables';
import {LaserFicheService} from '../../../services/laser-fiche.service';
import {DomSanitizer} from '@angular/platform-browser';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource} from '@angular/material';

@Component({
  selector: 'app-prueba-hecho',
  templateUrl: './prueba-hecho.component.html',
  styleUrls: ['./prueba-hecho.component.css']
})
export class PruebaHechoComponent implements OnInit {

  @ViewChild(InstanciaComponent) instanciaC: InstanciaComponent;
  @ViewChild(EvidenciasComponent) evidenciaC: EvidenciasComponent;
  fileToUpload: File = null;
  listFilesEvidencias: File[] = [];
  otra_instancia: false;
  cuenta_pruebas = false;
  require_identificarse: false;


  flgLectura = false;
 // listEvidencias : DocumentoDet[] = [];
  formEvidencias = new  FormGroup({
    cuentaPruebas: new FormControl(false),
    evidenciaFile : new FormControl()
  });

  flgSoloLectura = false;
  strDscEtiqueta2 = '(*.rar, *.zip, *.pdf, *.doc, *.docx, *.xls, *.xlsx, *.ppt, *.pptx, *.png, *.jpeg, *.jpg, *.gif, *.xps, *.txt, *.Gz, *.mp4, *.avi, *.mkv, *.flv, *.m4a, *.mp3, *.wav)';
  strDscEtiqueta1 = 'Seleccione el archivo';
  myDivInputFileDisabled = false;
  strDscColEtiq1 = 'Descripción';

  @ViewChild("formReg") myFormRegister: ElementRef;
  @ViewChild("formUpload") myFormUpload: ElementRef;
  @ViewChild("simpleInput") myFileInput: ElementRef;
  @ViewChild("iframeUpload") myIframeUpload: ElementRef;
  @ViewChild("divContentInputFile") myDivInputFile: ElementRef;

  dataSource: MatTableDataSource<DocumentoDet>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'Nombre evidencia', 'FchHrreg', 'ver', 'eliminar'];
  strDesEvidencia = '';
  strMatTablePaginator = strMatTablePaginator;
  numTopeMB: number = null;
  constructor(private entidadService: EntidadService, protected laserFicheService: LaserFicheService
  , private sanitizer: DomSanitizer,  public dialog: MatDialog,) { }

  ngOnInit() {

    if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
    this.numTopeMB = 20;
  }
  evidenciaCReadEnable() {
    this.flgSoloLectura = true;
    // console.log(this.listEvidencias);
  }

  evidenciaCReadDisable() {
    this.flgSoloLectura = false;
    // console.log(this.listEvidencias);
  }

  setCuenta_pruebas(flgValor: boolean) {

    this.cuenta_pruebas = flgValor;

  }

  cambioCuentaPruebas(event) {
    // console.log(event);
    // this.cuenta_pruebas = event.checked;
    this.setCuenta_pruebas(event.checked);
    this.formEvidencias.get('cuentaPruebas').setValue(this.cuenta_pruebas);
  }

  cambioOtraInstancia(event) {
      this.otra_instancia = event.checked;
  }

  pruebaHechoCReadEnable() {

    this.flgLectura = true;

  }

  pruebaHechoCReadDisable() {
    this.flgLectura = false;
  }
  setPruebaHechoComponent(fur: Fur) {
    // console.log("Prueba hechos: " + fur.cfurFlgpruebahechos);
    this.cuenta_pruebas = fur.cfurFlgexispruh == 'SI' ?  true : false;
    // console.log("Cuenta Pruebas" + this.cuenta_pruebas);

    setTimeout(() => {

      if (this.cuenta_pruebas) {

        // this.evidenciaC.evidenciaCReadEnable();

        if (this.flgLectura) {

          this.evidenciaC.evidenciaCReadEnable();

        } else {

          this.evidenciaC.evidenciaCReadDisable();

        }

        this.evidenciaC.setEvidenciaC(fur);

      }

    }, 0);

  }


  archivosAlfresco = [];
  urlIframe = '';
  hkey = '';
  idArchivoAlfresco;
  formRegister: FormGroup;
  formUpload: FormGroup;

  uploadFileAlfresco(event) {
    this.myDivInputFileDisabled = true;
    let newItem;
    if (event.target.files.length > 0) {


      for (let file of event.target.files) {

        const fileSizeMB = Math.round(file.size / (1024 * 1024));


        for(let listaAlfresco of this.archivosAlfresco){
          let cleanName = listaAlfresco.name.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'_');
          let cleanFileName = file.name.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'_');
          if(cleanName == cleanFileName){
            //this.modal("El archivo ya se encuentra en la lista, seleccione otro archivo.");
            openModalMensaje('Evidencias', 'El archivo ya se encuentra en la lista, seleccione otro archivo.', this.dialog);
            this.myFileInput.nativeElement.value = "";
            this.myDivInputFileDisabled = false;
            return;
          }
        }

        if (fileSizeMB > 1024) {
          //this.modal("El tamaño máximo es de 1gb. revisa el tamaño de los archivos que intenta cargar.");
          openModalMensaje('Evidencias', 'El tamaño máximo es de 1gb. revisa el tamaño de los archivos que intenta cargar.', this.dialog);
          console.log("fileSizeMB::::::::::::", fileSizeMB);
          this.myFileInput.nativeElement.value = "";
          this.myDivInputFileDisabled = false;
          return;
        }

        if (!(file.name.toLowerCase().includes(".pdf") ||
          file.name.toLowerCase().includes(".xpdf") ||
          file.name.toLowerCase().includes(".doc") ||
          file.name.toLowerCase().includes(".docx") ||
          file.name.toLowerCase().includes(".xls") ||
          file.name.toLowerCase().includes(".xlsx") ||
          file.name.toLowerCase().includes(".mp4") ||
          file.name.toLowerCase().includes(".mp3") ||
          file.name.toLowerCase().includes(".jpg") ||
          file.name.toLowerCase().includes(".zip") ||
          file.name.toLowerCase().includes(".rar") ||
          file.name.toLowerCase().includes(".dwg") ||
          file.name.toLowerCase().includes(".ppt") ||
          file.name.toLowerCase().includes(".pptx") ||
          file.name.toLowerCase().includes(".png"))) {
          //this.modal("Los formatos permitidos son .pdf, .xpdf, .doc, .docx, .xls, .xlsx, .mp4, .jpg, .png, .zip, .rar, dwg, .mp3 revisa el formato del archivo que intenta cargar");
          openModalMensaje('Evidencias', 'Los formatos permitidos son .pdf, .xpdf, .doc, .docx, .xls, .xlsx, .mp4, .jpg, .png, .zip, .rar, dwg, .mp3. ppt, pptx revisa el formato del archivo que intenta cargar', this.dialog);

          this.myFileInput.nativeElement.value = "";
          this.myDivInputFileDisabled = false;
          return;
        }

        let fileSize;
        if (fileSizeMB <= 0) {
          fileSize = Math.round(file.size / 1024) + ' KB'
        } else {
          fileSize = fileSizeMB + 'MB';
        }

        // REEMPLAZAR CARACATERES ESPECIALES NO SOPORTADOS POR ALFRESCO
        let fileNameArray = file.name.split('.');
        let realFileName = '';
        for (let i = 0; i < fileNameArray.length - 1 ; i++) {
          realFileName += fileNameArray[i];
        }
        realFileName = realFileName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'_');

        newItem = {
          'name': realFileName + '.' + fileNameArray[fileNameArray.length - 1],
          'size': fileSize,
          'status': '0',
          'uuid': '',
          'idArchivoalfresco':'0',
          'data' : {}
        }

        this.archivosAlfresco.push(newItem);
      }


      // OBTENER DATOS DE CARGA
      const data = {
        "tipoArchivo": "MPV",
        "pathAlfresco": "file.path.compromiso.ambiental"
      }
      console.log('agregarArchivo2.1');
      this.laserFicheService.agregarArchivo2(data).subscribe(resp => {
          console.log('agregarArchivo2');
          //console.log(resp);

          if (resp.estado) {
            this.urlIframe = resp.formActionURL;
            this.hkey = resp.keyId;
            this.idArchivoAlfresco = resp.idArchivo;
            // jcmf
            setTimeout(() => {
              //console.log("settimeout");
              this.myFormUpload.nativeElement.appendChild(this.myFormRegister.nativeElement.querySelector('input[type=file]'));
              this.myFormUpload.nativeElement.submit();
            }, 500);

            this.myDivInputFileDisabled = false;
          } else {
            this.myDivInputFileDisabled = false;
            this.archivosAlfresco.pop();
            //this.modalError("Tenemos problemas para realizar la carga de archivos.");
            openModalMensaje('Evidencias', 'Tenemos problemas para realizar la carga de archivos 1 .', this.dialog);

          }
        },
        err => {

          this.myDivInputFileDisabled = false;
          this.archivosAlfresco.pop();
          openModalMensaje('Evidencias', 'Tenemos problemas para realizar la carga de archivos. 3', this.dialog);

        });



    }
  }
  removeArchivoAlfresco(item: any, i: number) {
    console.log('removeArchivoAlfresco',item,i);
    if (item.status != '0') {
      this.archivosAlfresco.splice(i, 1);
    }
  }

  iframeURL(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  iframeLoaded() {
    if (this.idArchivoAlfresco == null) {
      return;
    }

    this.laserFicheService.getByIdArchivo(this.idArchivoAlfresco).subscribe(resp => {
     // console.log("archivo001");
      this.myFileInput.nativeElement.value = "";
      //console.log("archivo002");
      let statusCheck = false;
      this.archivosAlfresco.forEach(function (archivo, i) {
      //  console.log("archivo003", archivo);
       // console.log("index004", i);
        if (archivo.status == '0'   && !statusCheck) {
          archivo.status = '1';
          statusCheck = true;
          archivo.data = resp;
          archivo.uuid = resp.uuid;
          archivo.idArchivoalfresco = resp.idArchivoalfresco;
         // console.log("index005", i);
          return;
        }
        archivo.status = '2';
       // console.log("archivo006");
      });
     // console.log("archivo007");
      this.myDivInputFile.nativeElement.appendChild(this.myFileInput.nativeElement);
      //console.log("archivo008");
      this.myDivInputFileDisabled = false;
     // console.log("archivo009");
     // console.log(this.archivosAlfresco);
     // console.log("archivo010");
      //this.archivosAlfresco.slice(-1)[0].idArchivoAlfresco = resp.data.idArchivoalfresco;
      //this.archivosAlfresco.slice(-1)[0].uuid = resp.data.uuid;
      this.idArchivoAlfresco = null;
    }, error => {
     // console.log("catch getByIdArchivo");
      let index;
      this.archivosAlfresco.forEach(function (archivo, i) {
        console.log("archivo", archivo);
        console.log("index", i);
        if (archivo.status == '0') {
          index = i;
        }
      })
      // remove archivo
      this.archivosAlfresco.splice(index, 1)
      openModalMensaje('Evidencias', 'Tenemos problemas para realizar la carga de archivos.', this.dialog);
      // activar upload
      // this.myDivInputFile.nativeElement.appendChild(this.myFileInput.nativeElement);
      // this.myFileInput.nativeElement.value = "";
      this.myDivInputFileDisabled = false;

    });
  }

  getIframeHTML() {
    const element: HTMLIFrameElement = document.getElementById('uploadiframe') as HTMLIFrameElement;
    let algo = element.contentDocument ? element.contentDocument : element.contentWindow;
    console.log(algo);
  }


}
